const Role = {
  Eins: "MASTER",
  Superadmin: "SUPERADMIN",
  Admin: "ADMIN",
  User: "BASIC",
};

export default Role;
